module.exports = __webpack_public_path__ + "static/regulamin-swiadczenia-uslug-ladowania-PKN-ORLEN-flota-2024-9be35df3441f2ebe258250c885778439.pdf";